import React from 'react';

const Blog = () => {
  return (
    <div className="blog-page">
      <h1>Our Blog</h1>
      <p>Read our latest articles</p>
    </div>
  );
};

export default Blog;